import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";

function ConfirmDialog({
  open,
  title = "Confirm Action",
  content = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  leftButtonText = null,
  onConfirm,
  onCancel,
  onLeftButtonClick,
  disableConfirm = false,
  customActions,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth disableRestoreFocus>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {typeof content === "string" ? (
          <Typography>{content}</Typography>
        ) : (
          content
        )}
      </DialogContent>
      <DialogActions>
        {customActions ? (
          customActions
        ) : (
          <>
            {leftButtonText && onLeftButtonClick ? 
            <Button onClick={onLeftButtonClick}>
                {leftButtonText}
            </Button>
            : null}
            <div style={{flex: '1 0 0'}} />
            <Button
              onClick={onConfirm}
              color="primary"
              disabled={disableConfirm}
            >
              {confirmText}
            </Button>
            <Button onClick={onCancel} color="primary">
              {cancelText}
            </Button>
            
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;